// extracted by mini-css-extract-plugin
export default {"button":"ButtonGreenOriginal_button__p4OcB"};